import "@babel/polyfill";
import Vue from 'vue'
import VueLodash from 'vue-lodash'
import BootstrapVue from 'bootstrap-vue'
import piincHttp from '@/util/configureAxios.js'
import VueToastr from '@deveodk/vue-toastr'
import App from './App.vue'
import VueGtag from "vue-gtag";
import Multiselect from 'vue-multiselect'
import ControlResultBadge from '@/components/tasks/ControlResultBadge.vue';
import wysiwyg from "vue-wysiwyg";
import VueCarousel from 'vue-carousel';
import {config} from '@/config.js'
import router from './router'
import store from './store'
import VueCookie from 'vue-cookie'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// Free solid icons
import {
  faShareSquare, faClipboardList, faListAlt, faQuestion, faStopwatch, faSearch, faCheckSquare, faSyncAlt, faHandshake, faMicrochip, faUserSlash, faHistory, faCrosshairs, faShapes, faTag, faTags, faFileSignature, faUmbrella, faMap, faMedal, faBriefcase, faVideo, faWindowMinimize, faCircle, faTimesCircle, faCheckCircle, faCheckDouble, faPlus, faFileAlt, faRedoAlt, faInfo, faChevronCircleLeft, faPlay, faRedo, faArrowsAlt, faListOl, faPen, faFileDownload, faThumbsUp, faHome, faVirus, faTheaterMasks, faLink, faMeteor, faBook, faShieldAlt, faUserShield, faWifi, faArchive, faBalanceScale, faUserCog, faEraser, faClipboard, faDesktop, faCalendarAlt, faTasks, faStar, faBookOpen, faArrowUp, faArrowDown, faArrowRight, faInfoCircle, faListUl, faToggleOn, faToggleOff, faEye, faMinus, faMinusCircle, faPlusCircle, faComment, faArrowCircleRight, faSpinner, faExclamationTriangle, faPaperclip, faChevronUp, faChevronDown, faAngleDoubleLeft, faAngleDoubleRight, faAngleLeft, faAngleRight, faBinoculars, faFolderOpen, faKey, faFileInvoice, faProjectDiagram, faTimes, faCheck, faFilter, faSort, faDatabase, faExchangeAlt, faCaretUp, faCubes, faCogs, faCloudDownloadAlt, faCloudUploadAlt, faUsers, faCaretDown, faCaretRight, faBars, faCube, faUser, faCog, faBell, faWaveSquare, faChartBar, faLayerGroup, faChalkboardTeacher, faDiceD20, faSitemap, faPhone, faEnvelope, faExternalLinkAlt, faTrashAlt, faToolbox, faGripVertical, faUserTag, faCopy, faSignOutAlt, faPaperPlane, faSave, faAlignLeft, faThLarge, faUnlink, faAngleDown, faAdjust, faUserCheck, faLock, faHourglassHalf, faClock, faBellSlash, faExpand, faCompress, faFlag, faChevronLeft, faChevronRight, faEllipsisH, faDotCircle, faGlobe, faBuilding, faIdCard, faEyeSlash, faExclamationCircle, faBold, faItalic, faUnderline, faBan, faThumbsDown, faChartLine, faBolt, faBullseye
} from '@fortawesome/free-solid-svg-icons'

// Free brand icons
import { faMicrosoft, faGoogle, faReadme } from '@fortawesome/free-brands-svg-icons'

// Free regular icons
import { faSquare } from '@fortawesome/free-regular-svg-icons'

// Pro solid icons
import {
  faFile, faRobot, faSparkles, faRepeat, faRepeat1, faInboxIn, faText, faHeartBroken, faPuzzlePiece, faSpaceShuttle, faStarship, faRocket, faJoystick, faFolderTree, faArrowAltToBottom, faArrowAltFromTop, faArrowsAltH, faFileExclamation, faChartGantt, faUpRightFromSquare, faReplyClock, faRotateLeft, faFileWord, faHighlighter, faMousePointer, faSearchPlus, faSearchMinus, faStickyNote, faSignature, faDrawSquare, faH2, faH3, faIndent, faOutdent
} from '@fortawesome/pro-solid-svg-icons'

import moment from 'moment';
import {i18n} from './util/i18n.js'
import { loadProgressBar } from 'axios-progress-bar'
import Progress from 'vue-multiple-progress'
import "@/scss/fonts/greycliff-cf-regular/greycliff-cf-regular.css"
import "@/scss/app.scss"
import "vue-wysiwyg/dist/vueWysiwyg.css";
import "@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css"
import "vue-multiselect/dist/vue-multiselect.min.css"
import "axios-progress-bar/dist/nprogress.css"
import isGrantedModel from '@/util/ACL/isGrantedModel';
import { installModalScrollGuard } from '@/util/modalScrollGuard';
import installTabEdgeScroll from '@/util/tabEdgeScroll';
import permissionCheck from '@/util/ACL/permissionCheck';
import permissionMap from '@/util/ACL/permissionMap';

// Everyone uses the one maintained theme; the Light and Dark themes were removed in US 9391
localStorage.removeItem('theme')

import '@/scss/themes/complyon/styles.scss'

// Initiate Axios progress bar, without spinner
loadProgressBar({ showSpinner: false }, piincHttp)

// Prepare FontAwesome icons for use in app
library.add(faFile, faRobot, faSparkles, faRepeat, faRepeat1, faInboxIn, faShareSquare, faClipboardList, faListAlt, faText, faQuestion, faStopwatch, faHeartBroken, faPuzzlePiece, faSpaceShuttle, faStarship, faSearch, faCheckSquare, faRocket, faSyncAlt, faHandshake, faJoystick, faMicrochip, faUserSlash, faCogs, faHistory, faArrowsAltH, faArrowAltToBottom, faArrowAltFromTop, faCrosshairs, faShapes, faTag, faTags, faFolderTree, faFileSignature, faUmbrella, faMap, faMedal, faBriefcase, faVideo, faWindowMinimize, faCircle, faTimesCircle, faCheckCircle, faCheckDouble, faPlus, faFileAlt, faRedoAlt, faInfo, faChevronCircleLeft, faPlay, faRedo, faArrowsAlt, faListOl, faPen, faFileDownload, faThumbsUp, faHome, faVirus, faTheaterMasks, faLink, faMeteor, faBook, faShieldAlt, faUserShield, faWifi, faArchive, faBalanceScale, faUserCog, faEraser, faClipboard, faDesktop, faCalendarAlt, faTasks, faStar, faBookOpen, faArrowUp, faArrowDown, faArrowRight, faInfoCircle, faListUl, faToggleOn, faToggleOff, faEye, faMinus, faMinusCircle, faPlusCircle, faComment, faSquare, faArrowCircleRight, faSpinner, faExclamationTriangle, faPaperclip, faChevronUp, faChevronDown, faAngleDoubleLeft, faAngleDoubleRight, faAngleLeft, faAngleRight, faBinoculars, faFolderOpen, faKey, faFileInvoice, faProjectDiagram, faTimes, faCheck, faFilter, faSort, faDatabase, faExchangeAlt, faCaretUp, faCubes, faCogs, faCloudDownloadAlt, faCloudUploadAlt, faCloudUploadAlt, faUsers, faCaretDown, faCaretRight, faBars, faCube, faUser, faCog, faBell, faWaveSquare, faChartBar, faLayerGroup, faChalkboardTeacher, faDiceD20, faSitemap, faPhone, faEnvelope, faExternalLinkAlt,faTrashAlt, faMicrosoft, faGoogle, faReadme, faToolbox, faFileExclamation, faGripVertical, faUpRightFromSquare, faChartGantt, faReplyClock, faUserTag, faCopy, faSignOutAlt, faPaperPlane, faSave, faRotateLeft, faAlignLeft, faThLarge, faFileWord, faUnlink, faAngleDown, faAdjust, faUserCheck, faLock, faHourglassHalf, faClock, faBellSlash, faHighlighter, faMousePointer, faSearchPlus, faSearchMinus, faStickyNote, faSignature, faDrawSquare, faExpand, faCompress, faFlag, faChevronLeft, faChevronRight, faEllipsisH, faDotCircle, faGlobe, faBuilding, faIdCard, faEyeSlash, faExclamationCircle, faBold, faItalic, faUnderline, faH2, faH3, faIndent, faOutdent, faBan, faThumbsDown, faChartLine, faBolt, faBullseye)

// Register components globally in app
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('multiselect', Multiselect)
// Results of control tasks are shown in many lists (US 9478)
Vue.component('ControlResultBadge', ControlResultBadge)

const VueUploadComponent = require('vue-upload-component')
Vue.component('file-upload', VueUploadComponent)
Vue.component('file-upload-two', VueUploadComponent)

Vue.config.productionTip = false

// Tell Vue to use defined libraries
Vue.use(BootstrapVue)
Vue.use(VueCookie)
Vue.use(VueLodash)
Vue.use(VueToastr)
Vue.use(Progress)
Vue.use(VueCarousel)

Vue.use(wysiwyg, {
  hideModules: {"table": true, "image": true},
})

Vue.use(VueGtag, {
  config: { id: "G-SLEXCSX8Y2" }
});

const app = new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')

// Closing a dialog doesn't move the page
installModalScrollGuard(app);

Vue.mixin(isGrantedModel);

// Tab menus wider than the screen scroll when the mouse rests near their edge
installTabEdgeScroll();

// Use in all components as this.permissions.constantName
Vue.mixin({
  data: function () {
    return {
      permissions: permissionMap
    }
  }
})

moment.locale(localStorage.getItem('lang'))


// Filters

Vue.filter('truncate', function (text, stop, clamp) {
  if (text) {
    return text.slice(0, stop) + (stop < text.length ? clamp || '...' : '')
  }
})

Vue.filter('formatDate', function (date, format, dateOnly = false) {
  if (date) {
    if (dateOnly) {
      date = String(date).substring(0, 10)
      return moment(date).format(format ? format : config.dateFormat)
    }
    return moment(String(date)).format(format ? format : config.dateFormat)
  }
})

Vue.filter('formatDateTime', function (date, format) {
  if (date) {
    return moment(String(date)).format(format ? format : config.dateTimeFormat)
  }
})

Vue.filter('timestamp', function (date, format) {
  if (date) {
    return moment.unix(date).format(format ? format : config.dateTimeFormat);
  }
})

Vue.filter('formatRelativeDate', function (date, format) {
  if (date) {
    var localtime = moment.utc(String(date)).local();
    return localtime.fromNow();
  }
})

Vue.filter('lowerCase', function (text) {
  return text.toLowerCase().trim();
})

Vue.filter('slugify', function (text) {
  let lowercase = text.toLowerCase().trim();
  let underscore = lowercase.split(' ').join('_');
  return underscore;
})

Vue.filter('capitalize', function (text) {
  if (!text) {
    return ''
  }else{
    text = text.toString()
    return text.charAt(0).toUpperCase() + text.slice(1)
  }
})
